var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_1981",
    x: 0,
    y: 0,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.498,
    y1: 0.739,
    x2: 0.494,
    y2: 0.037,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed4715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#f4740c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#fa9605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#fdab01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#ffb300"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGO",
    transform: "translate(8.672 5.688)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.67, -5.69)",
    filter: "url(#Path_1981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1981-2",
    "data-name": "Path 1981",
    d: "M56,0A56,56,0,1,1,0,56,56,56,0,0,1,56,0Z",
    transform: "translate(9 6)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LOGO-2",
    "data-name": "LOGO",
    transform: "translate(-43.832 38.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781",
    transform: "translate(48.16 0.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779",
    transform: "translate(0.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_778",
    "data-name": "Group 778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M82.217,15.383c31.979,0,51.182,19.5,51.182,19.5l-32.715-.014,3.682-3.983.96-.086a9.432,9.432,0,0,1,1.074-.072c.474-.2-.014-.515-.014-.515h-.573a2.219,2.219,0,0,0-.416-.287l-3.31.014s-3.955-.244-5.76-.358-9.3-.357-9.3-.357l-2.464-1.792.76-.086L76.87,21.456l-8.926.043h0s-.53.229-.573.516c.559,0,1.074.043,1.074.043l2.092.429.123.336-3.19,4.005-.988-.014s-.333.354-.258.388c.178.079,2.141,1.218,2.141,1.218v.558l-2.4,3.052-7.179.058s-.315.185.029.4c0,.372-.015,2.436-.015,2.436l-28.357-.014C54.6,13.03,82.217,15.383,82.217,15.383Z",
    transform: "translate(-30.447 -15.309)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1612",
    "data-name": "Rectangle 1612",
    width: 102.048,
    height: 0.279,
    transform: "translate(0.452 27.474)",
    fill: "#fff",
    stroke: "#666",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_780",
    "data-name": "Group 780",
    transform: "translate(0 21.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M30.16,71.778c0-1.5.841-1.851,2.254-1.851h1.844c2.232,0,2.521.48,2.508,1.928H35.2v-.141c0-.368-.268-.474-.734-.474H32.753c-.827,0-.982.389-.982,1.025v.551c0,.742.155,1.024.9,1.024h1.674c.707,0,.918-.07.918-.706h1.568v.481c0,.861-.311,1.539-1.886,1.539H32.414C31,75.154,30.16,74.8,30.16,73.3Z",
    transform: "translate(-30.16 -69.927)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M49.825,70.072h4.732c1.208,0,1.533.6,1.533,1.518v.325c0,.686-.156,1.088-.876,1.257v.014c.466.085.855.29.855,1.13v.869H54.5v-.615c0-.538-.156-.713-.643-.713H51.393v1.328H49.825Zm1.568,2.515h2.593c.424,0,.579-.169.579-.536v-.17c0-.452-.226-.537-.72-.537H51.393Z",
    transform: "translate(-42.212 -70.016)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M77.445,70.072h2.409l1.773,3.292L83.4,70.072h2.408v5.115H84.283V71.513h-.014l-2.056,3.674H81.041l-2.056-3.674h-.014v3.674H77.445Z",
    transform: "translate(-59.14 -70.016)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M103.252,70.072h2.041l2.812,5.115H106.36l-.488-.9h-3.179l-.459.9h-1.751Zm.028,3.109h2.006l-1.018-1.922Z",
    transform: "translate(-73.259 -70.016)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M121.607,70.072h4.732c1.208,0,1.533.6,1.533,1.518v.325c0,.686-.156,1.088-.876,1.257v.014c.466.085.855.29.855,1.13v.869h-1.568v-.615c0-.538-.155-.713-.643-.713h-2.465v1.328h-1.568Zm1.568,2.515h2.592c.424,0,.579-.169.579-.536v-.17c0-.452-.226-.537-.72-.537h-2.451Z",
    transform: "translate(-86.205 -70.016)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M140.74,70.072h1.568v5.115H140.74Z",
    transform: "translate(-97.931 -70.016)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M147.744,70.072h2.43l2.946,3.716h.014V70.072H154.7v5.115h-2.43l-2.946-3.716h-.014v3.716h-1.568Z",
    transform: "translate(-102.224 -70.016)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M168.449,70.072h5.594v1.187h-4.026v.819h3.814v1.059h-3.814v.82h4.118v1.23h-5.685Z",
    transform: "translate(-114.913 -70.016)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M194.349,73.424h1.568c.008.544.227.586.679.586h1.921c.332,0,.671-.034.671-.43,0-.445-.184-.473-2.2-.473-2.359,0-2.627-.283-2.627-1.54,0-.926.084-1.639,2.062-1.639h2.19c1.809,0,1.978.615,1.978,1.511V71.6h-1.568c0-.374-.043-.529-.763-.529h-1.738c-.353,0-.593.12-.593.395,0,.445.19.46,1.871.452,2.437-.007,3,.142,3,1.632,0,1.377-.466,1.6-2.55,1.6h-1.9c-1.427,0-2-.268-2-1.377Z",
    transform: "translate(-130.787 -69.927)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M213.5,70.072h1.568v2.953c0,.65.233.9.876.9H217.5c.643,0,.876-.254.876-.9V70.072h1.569v3.292c0,1.272-.657,1.879-2.1,1.879H215.6c-1.441,0-2.1-.607-2.1-1.879Z",
    transform: "translate(-142.525 -70.016)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M232.872,70.072h4.275c1.49,0,1.85.749,1.85,1.753v.437c0,.764-.332,1.64-1.441,1.64h-3.115v1.285h-1.569Zm1.569,2.558h2.437a.478.478,0,0,0,.508-.544v-.2c0-.347-.17-.544-.643-.544h-2.3Z",
    transform: "translate(-154.396 -70.016)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M250.876,70.072h4.274c1.49,0,1.851.749,1.851,1.753v.437c0,.764-.333,1.64-1.441,1.64h-3.116v1.285h-1.568Zm1.568,2.558h2.437a.478.478,0,0,0,.508-.544v-.2c0-.347-.169-.544-.642-.544h-2.3Z",
    transform: "translate(-165.431 -70.016)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M268.88,70.072h1.568v3.8h3.525v1.314H268.88Z",
    transform: "translate(-176.465 -70.016)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M280.439,73.406l-2.832-3.334H279.5l1.724,2.091,1.723-2.091h1.893l-2.832,3.334v1.781h-1.569Z",
    transform: "translate(-181.813 -70.016)",
    fill: "#666"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_783",
    "data-name": "Group 783",
    transform: "translate(59.387 31.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_782",
    "data-name": "Group 782",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M61.3,95.809l-.554,2.472H59.87l-.249-1.107q-.064-.287-.1-.437l-.044-.217-.045-.217H59.42l-.044.217-.044.22c-.019.1-.05.242-.093.434l-.249,1.107H58.1l-.551-2.472h.6l.238,1.146c.03.143.059.3.088.46l.041.23.044.23h.01l.052-.23.049-.23c.026-.115.061-.268.106-.458l.269-1.148H59.8l.269,1.148c.05.216.086.368.106.458l.049.23.049.23h.013l.044-.23.041-.23q.044-.238.091-.46l.24-1.146Z",
    transform: "translate(-57.553 -94.751)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M73.753,95.809,73.2,98.281h-.874l-.249-1.107q-.064-.287-.1-.437l-.044-.217-.044-.217h-.018l-.044.217-.044.22q-.028.145-.093.434l-.249,1.107h-.887l-.551-2.472h.6l.238,1.146q.044.214.088.46l.041.23.044.23h.01l.052-.23.049-.23c.026-.115.061-.268.106-.458l.269-1.148h.755l.269,1.148.106.458.049.23.049.23h.013l.044-.23.041-.23q.044-.238.091-.46l.241-1.146Z",
    transform: "translate(-65.186 -94.751)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M86.209,95.809l-.554,2.472h-.874l-.249-1.107q-.064-.287-.1-.437l-.044-.217-.045-.217h-.018l-.044.217-.044.22c-.019.1-.05.242-.093.434L83.9,98.281h-.887l-.551-2.472h.6l.238,1.146q.044.214.088.46l.041.23.044.23h.01l.052-.23.049-.23c.026-.115.061-.268.106-.458l.269-1.148h.755l.269,1.148.106.458.049.23.049.23H85.2l.044-.23.041-.23q.045-.238.091-.46l.24-1.146Z",
    transform: "translate(-72.82 -94.751)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M96.173,100.551v.636h-.592v-.636Z",
    transform: "translate(-80.859 -97.658)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M102.715,97.292h.589v.085l-.036.375q-.109.512-1.06.512a1.263,1.263,0,0,1-.928-.252,2.326,2.326,0,0,1,0-2.018,1.185,1.185,0,0,1,.9-.259,1.438,1.438,0,0,1,.869.187.9.9,0,0,1,.228.713h-.587q0-.432-.5-.432-.354,0-.445.137a1.5,1.5,0,0,0-.091.672,1.3,1.3,0,0,0,.1.651q.1.133.487.133a.566.566,0,0,0,.391-.092A.649.649,0,0,0,102.715,97.292Z",
    transform: "translate(-84.21 -94.706)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M110.773,95.748h.592l-.036.346.013,0a.708.708,0,0,1,.667-.388q.652,0,.652.822V96.7H112.1c.007-.067.011-.111.011-.132,0-.264-.1-.4-.308-.4q-.44,0-.44.587V98.22h-.592Z",
    transform: "translate(-90.17 -94.69)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M119.234,95.764h.592l-.015.38.013,0a.738.738,0,0,1,.755-.412q.67,0,.745.458h.011a.725.725,0,0,1,.763-.458.761.761,0,0,1,.859.864v1.637h-.592V96.728q0-.526-.432-.525-.541,0-.541.587v1.446H120.8V96.7a.679.679,0,0,0-.082-.4.451.451,0,0,0-.345-.1q-.545,0-.545.6v1.433h-.592Z",
    transform: "translate(-95.356 -94.706)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M133.619,96.48h-.605a.7.7,0,0,1,.207-.595,1.527,1.527,0,0,1,.82-.15,1.56,1.56,0,0,1,.9.184.853.853,0,0,1,.235.7v1.616h-.592l.028-.339-.015,0q-.171.37-.789.37-.9,0-.9-.763t.918-.771q.613,0,.744.282h.011v-.4a.533.533,0,0,0-.1-.384.634.634,0,0,0-.414-.094Q133.618,96.133,133.619,96.48Zm.4.649q-.5,0-.5.346a.375.375,0,0,0,.1.316.828.828,0,0,0,.435.075q.541,0,.54-.365T134.014,97.129Z",
    transform: "translate(-103.739 -94.706)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M143.063,95.748h.592l-.036.346.013,0a.708.708,0,0,1,.667-.388q.652,0,.652.822V96.7h-.559c.007-.067.01-.111.01-.132q0-.4-.308-.4-.44,0-.44.587V98.22h-.592Z",
    transform: "translate(-109.96 -94.69)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M152.116,93.077v.494h-.592v-.494Zm0,1.058v2.472h-.592V94.135Z",
    transform: "translate(-115.145 -93.077)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M157.293,95.764h.587l-.023.416.013,0a.738.738,0,0,1,.776-.448q.876,0,.876.817v1.684h-.592V96.653l-.013-.173q-.042-.277-.434-.277-.6,0-.6.566v1.466h-.592Z",
    transform: "translate(-118.681 -94.706)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M168.734,97.44h.595v.1q0,.724-1.086.724a1.329,1.329,0,0,1-.964-.25,1.694,1.694,0,0,1-.228-1.063,1.44,1.44,0,0,1,.238-.97,1.294,1.294,0,0,1,.929-.249,1.215,1.215,0,0,1,.887.242,1.443,1.443,0,0,1,.225.95V97.1h-1.673c0,.055-.005.091-.005.108a.747.747,0,0,0,.112.486.615.615,0,0,0,.449.122.817.817,0,0,0,.424-.072A.365.365,0,0,0,168.734,97.44Zm.005-.7,0-.1a.512.512,0,0,0-.1-.383.747.747,0,0,0-.444-.088.614.614,0,0,0-.431.106.728.728,0,0,0-.1.463Z",
    transform: "translate(-124.661 -94.702)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M178.831,96.44h-.579c0-.021-.006-.036-.008-.047q-.018-.178-.1-.222a1.127,1.127,0,0,0-.407-.044q-.463,0-.463.3,0,.2.081.243a2.306,2.306,0,0,0,.552.062,1.761,1.761,0,0,1,.825.168.659.659,0,0,1,.191.561.706.706,0,0,1-.255.627,1.716,1.716,0,0,1-.914.175,1.671,1.671,0,0,1-.867-.158.664.664,0,0,1-.232-.59v-.062h.616a.453.453,0,0,0-.016.083q-.037.329.506.329.562,0,.561-.326t-.352-.313a2.363,2.363,0,0,1-1.046-.15.667.667,0,0,1-.252-.623.636.636,0,0,1,.23-.574,1.784,1.784,0,0,1,.885-.15,1.621,1.621,0,0,1,.831.145A.641.641,0,0,1,178.831,96.44Z",
    transform: "translate(-130.547 -94.702)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M188.629,95.809v2.472h-.592l.034-.424-.01,0a.753.753,0,0,1-.8.455.743.743,0,0,1-.84-.84v-1.66h.593v1.518a.672.672,0,0,0,.088.415.49.49,0,0,0,.365.1q.569,0,.569-.683v-1.35Z",
    transform: "translate(-136.534 -94.751)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M196.408,95.759h.6l-.023.367.013,0a.824.824,0,0,1,.8-.4.882.882,0,0,1,.743.268,1.694,1.694,0,0,1,.2.976,1.81,1.81,0,0,1-.2,1.014.873.873,0,0,1-.747.274.748.748,0,0,1-.76-.388h-.01v1.42h-.618Zm1.166.437q-.339,0-.442.153a1.311,1.311,0,0,0-.1.646,1.226,1.226,0,0,0,.111.639.525.525,0,0,0,.453.158q.347,0,.45-.15a2.075,2.075,0,0,0,0-1.3C197.971,96.246,197.815,96.2,197.574,96.2Z",
    transform: "translate(-142.653 -94.702)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M206.458,95.759h.6l-.023.367.013,0a.823.823,0,0,1,.8-.4.883.883,0,0,1,.744.268,1.694,1.694,0,0,1,.2.976,1.81,1.81,0,0,1-.2,1.014.873.873,0,0,1-.747.274.749.749,0,0,1-.761-.388h-.01v1.42h-.618Zm1.166.437q-.339,0-.442.153a1.307,1.307,0,0,0-.1.646,1.231,1.231,0,0,0,.111.639.525.525,0,0,0,.453.158q.347,0,.45-.15a2.071,2.071,0,0,0,0-1.3Q207.987,96.2,207.624,96.2Z",
    transform: "translate(-148.813 -94.702)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M217.1,93.077v3.53h-.592v-3.53Z",
    transform: "translate(-154.973 -93.077)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M223.81,95.809l-.649,2.627a1.589,1.589,0,0,1-.34.752.924.924,0,0,1-.65.192c-.067,0-.137,0-.209-.01v-.437c.052,0,.094,0,.129,0q.378,0,.479-.657h-.3l-.81-2.472h.636l.31,1.047.155.525c.009.034.033.122.072.263l.075.261h.013l.055-.261c.027-.134.045-.222.054-.263l.122-.525.238-1.047Z",
    transform: "translate(-158.004 -94.751)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M231.485,100.551v.636h-.592v-.636Z",
    transform: "translate(-163.788 -97.658)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M238.027,97.292h.589v.085l-.036.375q-.108.512-1.06.512a1.263,1.263,0,0,1-.928-.252,2.326,2.326,0,0,1,0-2.018,1.184,1.184,0,0,1,.895-.259,1.436,1.436,0,0,1,.869.187.894.894,0,0,1,.228.713H238q0-.432-.5-.432-.354,0-.444.137a1.5,1.5,0,0,0-.091.672,1.3,1.3,0,0,0,.1.651q.1.133.487.133a.568.568,0,0,0,.392-.092A.651.651,0,0,0,238.027,97.292Z",
    transform: "translate(-167.139 -94.706)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    d: "M246.988,95.735a1.354,1.354,0,0,1,.939.229,1.454,1.454,0,0,1,.223.966,1.806,1.806,0,0,1-.217,1.078,1.2,1.2,0,0,1-.916.256,1.4,1.4,0,0,1-.981-.238,1.648,1.648,0,0,1-.223-1.047,1.576,1.576,0,0,1,.219-1.011A1.368,1.368,0,0,1,246.988,95.735Zm-.005.468c-.247,0-.4.045-.47.134a1.2,1.2,0,0,0-.1.622,1.527,1.527,0,0,0,.1.7q.1.139.478.139t.467-.147a1.57,1.57,0,0,0,.1-.708,1.147,1.147,0,0,0-.1-.605Q247.347,96.2,246.982,96.2Z",
    transform: "translate(-172.931 -94.706)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M255.862,95.764h.592l-.015.38.013,0a.738.738,0,0,1,.755-.412q.67,0,.745.458h.01a.726.726,0,0,1,.763-.458.761.761,0,0,1,.859.864v1.637h-.592V96.728q0-.526-.432-.525-.541,0-.54.587v1.446h-.592V96.7a.685.685,0,0,0-.081-.4.451.451,0,0,0-.346-.1q-.545,0-.545.6v1.433h-.592Z",
    transform: "translate(-179.091 -94.706)",
    fill: "#666"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.87b46b1be8305d6b788d6a8e30dde668.svg";
export { ForwardRef as ReactComponent };